export const lavisFlatbread = {
  id: "lavisFlatbread",
  link: "/#/recipes/recipes/lavisFlatbread",
  name: "Lavis Flatbread",
  cuisine: "Alethi",
  summary: "Large corn tortillas",
  inspiration: "Tortilla",
  quantity: "12 6-7 inch flatbreads",
  time: "30 minutes",
  notes:
    "Many of the recipes in this collection can be eaten with flatbread. While it's perfectly acceptable to buy corn tortillas from the store, I figured I'd include a recipe here for people who want to make it themselves. I've made these larger than your traditional corn tortillas since the books seem to indicate that Alethi flatbreads are fairly large.",
  quotes:
    "“Very well,” Roshone said, taking a piece of flatbread from the basket and wrapping it around his skewer. (The Way of Kings ch 37)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/lavis-flatbread-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "maseca",
          display: "2 cups Mexican-style corn flour (Maseca)"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "water",
          display: "1 1/2 cups water, plus additional"
        }
      ]
    }
  ],
  steps: [
    "Combine all ingredients. Mix well. Knead to form a dough that doesn't crack when pressed lightly between thumb and forefinger, adding additional water 1/2 tsp at a time if needed.",
    "Divide dough into 12 pieces. Heat an electric griddle to high. One at a time, take a piece of dough and roll it into a ball, then press it in a lined tortilla press to a disk 6-7 inches in diameter.",
    "If you do not have a tortilla press, take a plastic shopping bag and slit it along the sides so it will lay flat. Place the dough ball on top and fold the bag over to cover. Roll the ball out with a rolling pin to 6-7 inches in diameter. Peel the top layer of plastic off, then hold it with the dough side in one hand and peel the other side of the plastic off with the other hand.",
    "Place on dough disk on the hot griddle and cook until both sides have just a few spots of color, flipping once."
  ]
}
